import { useTranslation } from 'react-i18next'
import useAuth from '../hooks/useAuth'
import { db } from '../lib/supabase'

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  const { user } = useAuth()
  const currentLang = i18n.language?.startsWith('zh') ? 'zh-CN' : 'en'

  const switchTo = async (lang) => {
    if (lang === currentLang) return
    await i18n.changeLanguage(lang)
    if (user) {
      db.updateLanguagePreference(user.id, lang).catch(console.error)
    }
  }

  return (
    <div className="flex items-center gap-1.5" role="radiogroup" aria-label="Language">
      <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.6 9h16.8M3.6 15h16.8" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a15 15 0 0 1 4 9 15 15 0 0 1-4 9 15 15 0 0 1-4-9 15 15 0 0 1 4-9Z" />
      </svg>
      <div className="flex bg-gray-100 rounded-full p-0.5">
        <button
          onClick={() => switchTo('en')}
          role="radio"
          aria-checked={currentLang === 'en'}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
            currentLang === 'en'
              ? 'bg-primary-700 text-white'
              : 'text-gray-500 hover:text-gray-700 cursor-pointer'
          }`}
        >
          EN
        </button>
        <button
          onClick={() => switchTo('zh-CN')}
          role="radio"
          aria-checked={currentLang === 'zh-CN'}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
            currentLang === 'zh-CN'
              ? 'bg-primary-700 text-white'
              : 'text-gray-500 hover:text-gray-700 cursor-pointer'
          }`}
        >
          中文
        </button>
      </div>
    </div>
  )
}
